import { render, staticRenderFns } from "./AccountMultiplePlus.vue?vue&type=template&id=fdda18a6"
import script from "./AccountMultiplePlus.vue?vue&type=script&lang=js"
export * from "./AccountMultiplePlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports